export default "https://cdn-static.gokick.com/assets/b18addbf7a1bb69f1adff96c45455352533f108a/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";